var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralMills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112.424,
    height: 65.555,
    viewBox: "0 0 112.424 65.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114029",
    "data-name": "Rectangle 114029",
    width: 112.424,
    height: 65.555,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_294905",
    "data-name": "Group 294905",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114026",
    "data-name": "Rectangle 114026",
    width: 2.46,
    height: 11.82,
    transform: "translate(109.964 17.029)",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_294904",
    "data-name": "Group 294904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294903",
    "data-name": "Group 294903",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258200",
    "data-name": "Path 258200",
    d: "M27.414,31.329c-.6,1.67-1.26,3.31-1.84,5a17.334,17.334,0,0,1,5.21,3.25c-.91,2.32-1.82,4.64-2.77,6.94a14.861,14.861,0,0,0-5-3.35q-1.5,4.065-3,8.14h-7.87q1.76-4.71,3.5-9.42a7.6,7.6,0,0,0-6.56,3.41,4.646,4.646,0,0,0-.8,3.12,8.491,8.491,0,0,0,3.13,6,15.372,15.372,0,0,0,8.74,3.08,19.619,19.619,0,0,0,7.64-.81,11.772,11.772,0,0,0,5.68-3.87,12.332,12.332,0,0,0,2.4-8.5c-.21-2.29-.76-4.53-1.18-6.78a41.3,41.3,0,0,1-.89-7.71,24.981,24.981,0,0,1-6.39,1.55m-8.38-15.66a5.136,5.136,0,0,0,0,4.32,7.171,7.171,0,0,0,3.38,3.55c.31-.71.57-1.45.85-2.17a15.352,15.352,0,0,0,1.1-3.52,3.849,3.849,0,0,0-.68-3,2.77,2.77,0,0,0-2.94-.81,2.91,2.91,0,0,0-1.69,1.61m2-9.36h1.83a10.7,10.7,0,0,1,5.15,1.69,9,9,0,0,1,3.67,5.23,13.3,13.3,0,0,1-.57,8c-.31.89-.64,1.78-1,2.67a8.164,8.164,0,0,0,4-2.2,8.941,8.941,0,0,0,2.09-4.28h8a31.422,31.422,0,0,0-2.34,11.53c0,4.57,1.69,8.91,2.15,13.43a23.373,23.373,0,0,1-.64,9.17,17.885,17.885,0,0,1-4.28,7.43,20,20,0,0,1-7.23,4.74,28.478,28.478,0,0,1-10.92,1.79,25.237,25.237,0,0,1-12.69-3.43,17.362,17.362,0,0,1-7.33-8.63,14.607,14.607,0,0,1,.37-11.22,13.218,13.218,0,0,1,6.23-6.23A20.079,20.079,0,0,1,18.3,34.4c.51-1.32,1-2.65,1.53-4a15.069,15.069,0,0,1-7.45-6.46A12.519,12.519,0,0,1,14,9.689a10.554,10.554,0,0,1,7-3.35",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258201",
    "data-name": "Path 258201",
    d: "M40.244,14.469c4-3.07,6.1-4.79,7.41-7.07,1.84-3.2.73-5.91-1.61-7a4.41,4.41,0,0,0-5.8,2.09A4.41,4.41,0,0,0,34.444.4c-2.33,1.06-3.45,3.77-1.61,7,1.31,2.28,3.36,4,7.41,7.07",
    fill: "#e2231a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258202",
    "data-name": "Path 258202",
    d: "M51.024,23.219h0A5.82,5.82,0,0,1,56.8,17.358h.161a6.222,6.222,0,0,1,4.45,1.55l-1.56,1.84a4.178,4.178,0,0,0-3-1.15,3.4,3.4,0,0,0-3.25,3.53,3.4,3.4,0,0,0,3.2,3.585c.076,0,.151.006.226,0a4,4,0,0,0,2.35-.68v-1.62h-2.51v-2.15h4.92v4.92a7.343,7.343,0,0,1-4.84,1.8,5.67,5.67,0,0,1-5.993-5.328c-.01-.167-.012-.335-.007-.5",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258203",
    "data-name": "Path 258203",
    d: "M69.664,23.829a1.86,1.86,0,0,0-1.83-1.84,1.941,1.941,0,0,0-1.88,1.84Zm-6.12.73h0a4.319,4.319,0,0,1,4.115-4.515c.058,0,.117-.005.175-.005,2.9,0,4.23,2.25,4.23,4.71v.65h-6a2,2,0,0,0,2.12,1.7,2.85,2.85,0,0,0,2.11-.89l1.41,1.25a4.58,4.58,0,0,1-8.08-2.87",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258204",
    "data-name": "Path 258204",
    d: "M73.884,20.169h2.46V21.4a3.068,3.068,0,0,1,2.54-1.39c1.86,0,2.95,1.23,2.95,3.22v5.62h-2.46v-4.84c0-1.17-.55-1.77-1.49-1.77s-1.54.6-1.54,1.77v4.84h-2.46v-8.68",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258205",
    "data-name": "Path 258205",
    d: "M89.674,23.829a1.86,1.86,0,0,0-1.83-1.84,1.941,1.941,0,0,0-1.88,1.84Zm-6.12.73h0a4.319,4.319,0,0,1,4.115-4.515c.058,0,.117-.005.175-.005,2.9,0,4.23,2.25,4.23,4.71v.65h-6a2,2,0,0,0,2.12,1.7,2.839,2.839,0,0,0,2.1-.89l1.41,1.25a4.58,4.58,0,0,1-8.08-2.87",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258206",
    "data-name": "Path 258206",
    d: "M93.9,20.169h2.46v1.75a2.681,2.681,0,0,1,2.77-1.91v2.57H99c-1.63,0-2.64,1-2.64,3.06v3.21H93.9v-8.68",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258207",
    "data-name": "Path 258207",
    d: "M105.394,25.749v-.44a3.8,3.8,0,0,0-1.57-.32c-1.05,0-1.7.42-1.7,1.2,0,.66.55,1.05,1.34,1.05,1.15,0,1.93-.63,1.93-1.52m-5.65.57h0c0-1.89,1.44-2.77,3.5-2.77a6.175,6.175,0,0,1,2.12.36v-.13c0-1-.63-1.59-1.86-1.59a6.369,6.369,0,0,0-2.4.47l-.62-1.88a7.651,7.651,0,0,1,3.37-.7,4,4,0,0,1,2.93,1,3.782,3.782,0,0,1,.94,2.77v5h-2.38v-.94a3.339,3.339,0,0,1-2.62,1.1,2.68,2.68,0,0,1-2.981-2.341,2.615,2.615,0,0,1-.019-.319",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258208",
    "data-name": "Path 258208",
    d: "M51.524,33.139h2.69l2.98,4.79,2.98-4.79h2.69v11.34h-2.48v-7.4l-3.19,4.84h-.07l-3.15-4.8v7.36h-2.45Z",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258209",
    "data-name": "Path 258209",
    d: "M65.434,35.749h2.46v8.68h-2.46Zm-.06-3.14h2.59V34.8h-2.59Z",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114027",
    "data-name": "Rectangle 114027",
    width: 2.46,
    height: 11.82,
    transform: "translate(70.324 32.659)",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114028",
    "data-name": "Rectangle 114028",
    width: 2.46,
    height: 11.82,
    transform: "translate(75.214 32.659)",
    fill: "#0033a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258210",
    "data-name": "Path 258210",
    d: "M79.314,43.329l1.05-1.62a4.91,4.91,0,0,0,2.74,1c.71,0,1-.26,1-.65,0-.53-.84-.71-1.8-1-1.21-.36-2.59-.92-2.59-2.61,0-1.76,1.42-2.75,3.17-2.75a6,6,0,0,1,3.24,1l-.94,1.7a5.144,5.144,0,0,0-2.35-.81c-.6,0-.91.26-.91.6,0,.49.82.71,1.76,1,1.21.4,2.62,1,2.62,2.57,0,1.93-1.44,2.8-3.32,2.8a6.078,6.078,0,0,1-3.72-1.31",
    fill: "#0033a0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralMills);
export default __webpack_public_path__ + "static/media/general-mills.61bf1e6ef4af8379e88029e3c1095757.svg";
export { ForwardRef as ReactComponent };